import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/au_qld.jpg'


const _withScopeId = n => (_pushScopeId("data-v-08f81135"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "specailExperience" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "w-100",
  src: _imports_0
}, null, -1))
const _hoisted_3 = { class: "p-3 container" }
const _hoisted_4 = { class: "row py-5 text-start" }
const _hoisted_5 = { class: "col-12 p-1" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bg-light-green footer" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TimeLineCard = _resolveComponent("TimeLineCard")!
  const _component_TimelineItem = _resolveComponent("TimelineItem")!
  const _component_Timeline = _resolveComponent("Timeline")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h1", null, _toDisplayString(_ctx.$t("SECTION_TITLE.SE")), 1),
          _createVNode(_component_Timeline, null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$tm('SE'), (experience) => {
                return (_openBlock(), _createBlock(_component_TimelineItem, { class: "fs-6" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(experience.TIME), 1),
                    _createVNode(_component_TimeLineCard, {
                      title: experience.TITLE,
                      "sub-title": experience.LOCATION,
                      des: experience.DESCRIPTIONS,
                      img: experience.IMG,
                      imgDes: experience.IMG_DES
                    }, null, 8, ["title", "sub-title", "des", "img", "imgDes"])
                  ]),
                  _: 2
                }, 1024))
              }), 256))
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _hoisted_6
  ]))
}